import { brandAssets } from './brandAssets';

type BrandLockupProps = {
  /** Dark charcoal panel vs light auth panel. */
  tone?: 'onDark' | 'onLight';
  className?: string;
};

/** Wordmark-only brand mark for the login panel. */
export function BrandLockup({ tone = 'onDark', className = '' }: BrandLockupProps) {
  return (
    <img
      src={brandAssets.wordmark}
      alt="GhostScreens"
      draggable={false}
      className={[
        'h-14 w-auto select-none object-contain object-left rtl:object-right',
        className,
        tone === 'onDark' ? 'brightness-0 invert' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    />
  );
}
